/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOShiftAndScheduleList from '../ShiftAndScheduleList/DTOShiftAndScheduleList';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { shiftAndScheduleService } from '../../../../api/services/shiftAndScheduleService';
import { setTimeSheetLoader } from '../../../../infra/aggregates/myProfile/AttendanceAggregates/getEmpTimeSheetSlice';
import { useTranslation } from 'react-i18next';

import ShiftAndShcedule2 from '../ShiftAndScheduleList/v2-ui/ShiftAndShcedule2';

function ShiftAndScheduleListController2() {
  const { t, i18n } = useTranslation();
  const [allShiftListsData, setAllShiftListsData] = useState<any>([]);

  const isLaoding = useAppSelector(
    (state) => state.getEmpTimeSheetSlice.timeSheetLoader,
  );
  const dispatch = useAppDispatch();

  const selector = useAppSelector((state) => state);
  function callBackFunc(data: any) {
    setAllShiftListsData(data);
  }

  function filter_shift_schedule_list(data: any) {
    dispatch(setTimeSheetLoader(true));

    const _fromDate = data?.from_date;
    const _toDate = data?.to_date;

    shiftAndScheduleService
      .getAllShifts(selector.authSlice.emp_id, 0, _fromDate, _toDate)
      .then((res: any) => {
        setAllShiftListsData(res?.data);
        dispatch(setTimeSheetLoader(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setTimeSheetLoader(false));
      });
  }

  return (
    <>
      <DTOShiftAndScheduleList setShiftScheduleList={callBackFunc} />
      <ShiftAndShcedule2 />
    </>
  );
}
export default ShiftAndScheduleListController2;
